<h1 mat-dialog-title>Layer already exists</h1>
<mat-dialog-content>The selected layer is already present on the map. Are you sure you want to add this layer again?</mat-dialog-content>
<mat-dialog-actions class="action-row">
  <button mat-raised-button [mat-dialog-close]="true">Yes</button>
  <span class="spacer"></span>
  <button mat-raised-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
